<template>
    <form id="form-filter">
        <div class="filter-mobile-menu">
            <span>{{ __('Termékkategóriák') }}</span>
            <svg class="icon" viewBox="0 0 150 120">
                <rect x="0" y="0" width="150" height="20" rx="15"></rect>
                <rect x="0" y="100" width="150" height="20" rx="15"></rect>
                <rect x="0" y="50" width="150" height="20" rx="15"></rect>
            </svg>
        </div>

        <div class="filters is-expanded">

            <fieldset v-for="(menuItem, index) in menuItems">

                <legend class="toggle-category">
                    <span>{{ menuItem.title }}</span>
                    <i class="fa fa-chevron-down toggle-icon" aria-hidden="true"></i>
                </legend>

                <div :style="[ isActive(menuItem.url, 0, index) ?  null : {display: 'none'}]">
                <span
                    v-for="menuItem in menuItem.children"
                    v-if="menuItem.children"
                    class="filter">

                    <span
                        v-if="menuItem.children.length > 0" class="menulabel">
                        {{ menuItem.title }}
                    </span>
                     <a
                         v-else
                         :href="menuItem.url"
                         class="filter"
                         :title="menuItem.title">
                         {{ menuItem.title }}
                     </a>

                    <div class="menu" :style="[ isActive(menuItem.url, 1, null) ?  {display: 'block'} : {display: 'none'}]">
                        <template
                            v-for="menuItem in menuItem.children">
                            <div
                                class="menu"
                                v-if="menuItem.children.length">
                                 <a
                                     v-for="menuItem in menuItem.children"
                                     :href="menuItem.url"
                                     class="filter"
                                     :title="menuItem.title">
                                     {{ menuItem.title }}
                                </a>
                            </div>
                            <a
                                v-else
                                :href="menuItem.url"
                                class="filter"
                                :title="menuItem.title">
                                {{ menuItem.title }}
                            </a>
                        </template>
                    </div>
                </span>

                    <a v-else :href="menuItem.url" class="filter" :title="menuItem.title">
                        {{ menuItem.title }}
                    </a>

                </div>
            </fieldset>

            <fieldset class="advanced-filters">
                <legend class="toggle-category">
                    <span> {{ __('Részletes szűrők') }}</span>
                    <i class="fas fa-chevron-up toggle-icon" aria-hidden="true"></i>
                </legend>
                <div class="advanced-filters-label"><span>{{ __('Részletes keresés') }}</span></div>
                <div class="group-filters">
                    <div class="group-filter">
                        <label>{{ __('Ár') }}</label>
                        <div>
                            <vue-slider
                                v-model="price"
                                :min="filters.price.min"
                                :height="3"
                                :width="195"
                                :max="filters.price.max"
                                :process-style="{ backgroundColor: '#b7d630' }"
                                :tooltip-style="{ backgroundColor: '#b7d630', borderColor: 'grey' }"
                                :enable-cross="false"
                                class="ml-2"
                            ></vue-slider>
                        </div>
                    </div>

                    <div v-if="filters.properties.length > 0"
                         class="group-filter"
                    >
                        <label>{{ __('Tulajdonság') }}</label>
                        <vue-multiselect
                            id="property-filter"
                            v-model="properties"
                            :options="filters.properties"
                            track-by="id"
                            label="name"
                            :show-labels="false"
                            :multiple="true"
                            :hideSelected="true"
                            :placeholder="__('Válassz')">
                        </vue-multiselect>
                    </div>

                    <div class="group-filter">
                        <label>{{ __('Szín') }}</label>
                        <vue-multiselect
                            id="color-filter"
                            v-model="colors"
                            :options="filters.colors"
                            :show-labels="false"
                            track-by="id"
                            :multiple="true"
                            :hideSelected="true"
                            :placeholder="__('Válassz')">
                            <template slot="tag" slot-scope="{ option, remove }">
                                <span class="multiselect__tag">
                                    <div
                                        :style="'background-color: ' + option.color + ';height: 15px; width: 15px; display: inline-flex; margin-bottom: -3px;margin-left: 5px;'"></div>
                                    <span>{{ option.name }}</span>
                                  <i aria-hidden="true" tabindex="1" @keypress.enter.prevent="remove(option)"
                                     @mousedown.prevent="remove(option)" class="multiselect__tag-icon"></i>
                                </span>
                            </template>

                            <template slot="singleLabel" slot-scope="props">
                                <span :title="props.option.name">
                                    <div
                                        :style="'background-color: ' + props.option.color + ';height: 15px; width: 15px; display: inline-flex; margin-bottom: -3px;margin-left: 5px;'"></div>
                                    <span>{{ props.option.name }}</span>
                                </span>
                            </template>
                            <template slot="option" slot-scope="props">
                                <div style="display: flex">
                                    <div :title="props.option.name"
                                         :style="'background-color: ' + props.option.color + ';height:15px;width:15px;margin-right: 5px'"></div>
                                    <span style="margin-top: -1px">{{ props.option.name }}</span>
                                </div>
                            </template>
                        </vue-multiselect>
                    </div>

                    <div class="group-filter">
                        <label>{{ __('Méret') }}</label>
                        <vue-multiselect
                            id="size-filter"
                            v-model="sizes"
                            :options="filters.sizes"
                            track-by="name"
                            label="name"
                            :show-labels="false"
                            :multiple="true"
                            :hideSelected="true"
                            :placeholder="__('Válassz')">
                        </vue-multiselect>
                    </div>

                    <input type="submit" :value="__('Keresés')" id="search-submit" @click.prevent="filter">
                    <button class="filter-reset" onclick="clearFilters()">{{ __('Szűrők törlése') }}</button>
                </div>
            </fieldset>
        </div>
    </form>
</template>

<script>
import 'vue-slider-component/theme/default.css'
import VueSlider from 'vue-slider-component'
import Multiselect from 'vue-multiselect'

export default {
    name: 'ProductFilters',
    components: {
        VueSlider,
        Multiselect
    },

    props: {
        filters: {
            type: Object,
            required: true
        },
        menuItems: {
            type: Array,
            required: true
        },
        urlSegments: {
            type: Array,
            required: true
        },
        initFilters: {
            type: Object|Array,
            required: true
        }
    },

    data() {
        return {
            colors: [],
            sizes: [],
            properties: [],
            price: [this.filters.price.min, this.filters.price.max]
        }
    },

    created() {
        this.loadInitFilters();
    },

    methods: {
        filter() {
            this.$bus.$emit('filter-product-list', {
                colors: this.colors,
                sizes: this.sizes,
                properties: this.properties,
                price: this.price,
            })
        },

        isActive(url, index, menuItemIndex) {
            if(menuItemIndex === this.menuItems.length - 1) return true

            if(this.urlSegments.length < index) return false

            return url.includes('/' + this.urlSegments[index])
        },

        loadInitFilters() {
            var min = Math.min.apply(null, this.initFilters.price),
                max = Math.max.apply(null, this.initFilters.price);

            if (min >= 0 && max >= 0) {
                this.price = [min, max];
            }

            if (this.initFilters.colors) {
                for (let i = 0; i < this.initFilters.colors.length; i++) {
                    const color = this.filters.colors.find(x => x.id == this.initFilters.colors[i]);
                    if (this.colors.indexOf(color) === -1) {
                        this.colors.push(color);
                    }
                }
            }

            if (this.initFilters.sizes) {
                for (let i = 0; i < this.initFilters.sizes.length; i++) {
                    const size = this.filters.sizes.find(x => x.name == this.initFilters.sizes[i]);
                    if (this.sizes.indexOf(size) === -1) {
                        this.sizes.push(size);
                    }
                }
            }

            if (this.initFilters.properties) {
                for (let i = 0; i < this.initFilters.properties.length; i++) {
                    const property = this.filters.properties.find(x => x.id == this.initFilters.properties[i]);
                    if (this.properties.indexOf(property) === -1) {
                        this.properties.push(property);
                    }
                }
            }
        },
    }
}
</script>

<style scoped>
</style>
